// REA-CI/screens/MapScreen.tsx

import React from "react";
import {
  View,
  StyleSheet,
  Platform,
  Text,
  TouchableOpacity,
} from "react-native";
import { FontAwesome } from "@expo/vector-icons";

const MapScreen = ({ navigation }: any) => {
  // Web: Render the Mapbox iframe
  const renderWebMap = () => (
    <View style={styles.webMapContainer}>
      <iframe
        width="100%"
        height="100%"
        src="https://api.mapbox.com/styles/v1/reaci/cm3p5xma8004n01sg5wu93pyu.html?title=false&access_token=pk.eyJ1IjoicmVhY2kiLCJhIjoiY20zb3p2bWhyMDlvaTJqcHNqZnM2N3RzdCJ9.Xg5CUS-wOKDI4VLaPWLi8w&zoomwheel=false#8.84/5.5439/-3.9798"
        title="REA-CI"
        style={{ border: "none" }}
      ></iframe>
    </View>
  );

  // Native: Show placeholder message for now
  const renderNativeMap = () => (
    <View style={styles.nativeMapContainer}>
      <Text style={styles.nativeMapText}>
        The map preview is only available on the web. Native maps will be
        supported in future updates.
      </Text>
    </View>
  );

  return (
    <View style={styles.container}>
      {Platform.OS === "web" ? renderWebMap() : renderNativeMap()}

      {/* Bottom Navigation */}
      <View style={styles.bottomNavigation}>
        <TouchableOpacity
          style={styles.navItem}
          onPress={() => navigation.navigate("BuyerHomeScreen")}
        >
          <FontAwesome name="home" size={24} color="#333" />
          <Text style={styles.navText}>Home</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.navItem}>
          <FontAwesome name="map" size={24} color="green" />
          <Text style={[styles.navText, styles.activeNavText]}>Maps</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.navItem}
          onPress={() => navigation.navigate("ListingsScreen")}
        >
          <FontAwesome name="list" size={24} color="#333" />
          <Text style={styles.navText}>Listings</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.navItem}
          onPress={() => navigation.navigate("BuyerProfileScreen")}
        >
          <FontAwesome name="user" size={24} color="#333" />
          <Text style={styles.navText}>Profile</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#f8f8f8",
  },
  webMapContainer: {
    flex: 1,
    backgroundColor: "#e0e0e0",
  },
  nativeMapContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f8f8f8",
  },
  nativeMapText: {
    fontSize: 16,
    color: "#666",
    textAlign: "center",
    marginHorizontal: 20,
  },
  bottomNavigation: {
    flexDirection: "row",
    justifyContent: "space-around",
    backgroundColor: "#ffffff",
    paddingVertical: 10,
    borderTopWidth: 1,
    borderTopColor: "#e0e0e0",
  },
  navItem: {
    alignItems: "center",
  },
  navText: {
    fontSize: 12,
    color: "#666",
    marginTop: 5,
  },
  activeNavText: {
    color: "green", // Highlight active section
    fontWeight: "bold",
  },
});

export default MapScreen;
